import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { PreviewQuestionnaireComponent } from '../../questionnaires/preview-questionnaire.component';
import { CompleteUserFormComponent } from '../../questionnaires/user-form/complete-user-form.component'
import { QuestionnairePrintReportComponent } from './questionnaire-print.component';
import { QuestionnaireService } from '../../services/questionnaire.service';

export function resolveQuestionnaireById(questionnaireService: QuestionnaireService, transition: Transition) {
    let params = transition.params();

    return questionnaireService
        .getQuestionnaireById(params.questionnaireId)
        .toPromise();
}

export function resolveRecalculate(transition: Transition, questionnaireService: QuestionnaireService) {
    let params = transition.params();

    return questionnaireService.recalculate({ FormID: params.questionnaireId })
        .toPromise();
}

export function resolveUserForm(questionnaireService: QuestionnaireService, transition: Transition) {
    let params = transition.params();

    return questionnaireService
        .getUserForm(params.userFormId)
        .toPromise();
}

export function resolveTrue() {
    return true;
}

export let QuestionnairePrintReportStates: Ng2StateDeclaration[] = [{
    name: 'print.questionnaire',
    url: '/questionnaire',
    abstract: true,
    views: {
        'content@print': {
            component: QuestionnairePrintReportComponent
        }
    },
    resolve: [{
        token: 'printMode',
        resolveFn: resolveTrue
    }]
}, {
    name: 'print.questionnaire.preview',
    url: '/preview/:questionnaireId',
    views: {
        'content@print.questionnaire': {
            component: PreviewQuestionnaireComponent
        }
    },
    resolve: [{
        token: 'questionnaire',
        deps: [QuestionnaireService, Transition],
        resolveFn: resolveQuestionnaireById
    }, {
        token: 'formAnswers',
        deps: [Transition, QuestionnaireService],
        resolveFn: resolveRecalculate
    }]
}, {
    name: 'print.questionnaire.userForm',
    url: '/user-form/:userFormId',
    views: {
        'content@print.questionnaire': {
            component: CompleteUserFormComponent
        }
    },
    resolve: [{
        token: 'userFormDetails',
        deps: [QuestionnaireService, Transition],
        resolveFn: resolveUserForm
    }]
}];